import { useEffect } from "react";

import AdminContentSettingsSearchFormOverlay from "@/admin/AdminContentSettingsSearchFormOverlay";
import { useAdminContentSettingsContext } from "@/search/AdminContentSettingsContext/AdminContentSettingsContext";
import { useSearchPageContext } from "@/search/Langston/SearchPageProvider";
import { useContentSettings } from "@/search/Langston/useContentSettings";

export const SearchContentSettings = () => {
  const { setContentSettingsToggleEnabled } = useAdminContentSettingsContext();
  const {
    getters: { sendAdminContentSettings },
  } = useSearchPageContext();

  const { invokeContentSettingsSearchModeChange } = useContentSettings();

  useEffect(() => {
    setContentSettingsToggleEnabled(sendAdminContentSettings);
  }, [sendAdminContentSettings]);

  return (
    <>
      <AdminContentSettingsSearchFormOverlay
        invokeContentSettingsSearchModeChange={
          invokeContentSettingsSearchModeChange
        }
      />
    </>
  );
};
